(function () {
	'use strict';

	var FLUSH_INTERVAL_MS = 7000;
	var LS_EVENTS = 'bloom_session_events';

	// Event types that MUST reach the server even when the visitor is in
	// test-mode (superuser / ?bs_test=1) and hasn't enabled the global
	// flush-to-server cookie. These are user-submitted contributions that
	// would otherwise be silently dropped — defeating the purpose of the form.
	var FORCE_FLUSH_TYPES = { product_fit_feedback: true };

	function readEvents() {
		try { return JSON.parse(localStorage.getItem(LS_EVENTS) || '[]') || []; }
		catch (e) { return []; }
	}

	function writeEvents(arr) {
		try { localStorage.setItem(LS_EVENTS, JSON.stringify(arr)); } catch (e) {}
	}

	// Test-user (superuser/?bs_test=1) по умолчанию НЕ флушит. В debug-панели
	// есть чекбокс "flush to server" — если включён, в cookie кладётся
	// bloom_session_flush_to_server=1, и flush работает как у обычных юзеров.
	// Регулярные юзеры (без __bsTestUser) всегда флушат.
	function isFlushAllowed() {
		if (!window.__bsTestUser) return true;
		var m = document.cookie.match(/(?:^|;\s*)bloom_session_flush_to_server=([^;]*)/);
		return m && m[1] === '1';
	}

	function flush() {
		var allowed = isFlushAllowed();
		var all = readEvents();
		// In test-mode without flush-to-server, only events with types in
		// FORCE_FLUSH_TYPES go through. Otherwise everything _unsent flushes.
		var pending = all.filter(function (e) {
			if (!e._unsent) return false;
			if (allowed) return true;
			return !!FORCE_FLUSH_TYPES[e.type];
		});
		if (pending.length === 0) return;

		var visitor_id = window.__bsVisitorId;
		var session    = window.__bsSession;
		if (!visitor_id || !session) return;

		var batch = {
			v: 1,
			host: window.__bsHost,
			visitor_id: visitor_id,
			session_id: session.session_id,
			events: pending.map(function (e) {
				var clean = {};
				for (var k in e) {
					if (k === '_unsent') continue;
					if (k.charAt(0) === '_') continue;
					clean[k] = e[k];
				}
				return clean;
			})
		};

		var payload = JSON.stringify(batch);
		var url = window.__bsApiBase + '/session';

		function markAccepted(acceptedIds) {
			var setIds = {};
			acceptedIds.forEach(function (id) { setIds[id] = true; });
			var current = readEvents();
			current.forEach(function (e) { if (setIds[e.event_id]) e._unsent = false; });
			var trimmed = current.filter(function (e) { return e._unsent; }).slice(-200).concat(
				current.filter(function (e) { return !e._unsent; }).slice(-50)
			);
			writeEvents(trimmed);
		}

		if (navigator.sendBeacon) {
			try {
				var blob = new Blob([payload], { type: 'application/json' });
				var ok = navigator.sendBeacon(url, blob);
				if (ok) {
					markAccepted(pending.map(function (e) { return e.event_id; }));
					return;
				}
			} catch (e) {}
		}

		fetch(url, {
			method: 'POST',
			credentials: 'include',
			keepalive: true,
			headers: { 'Content-Type': 'application/json' },
			body: payload
		})
		// 200 — нормальный успех; 429 — server отбросил из-за rate-limit, клиент должен
		// очистить свою очередь по accepted чтобы не ретраить вечно. Только 4xx/5xx без 429
		// и сетевые ошибки попадают в .catch — там флашер просто молча подождёт следующего тика.
		.then(function (r) {
			if (r.ok || r.status === 429) return r.json();
			return null;
		})
		.then(function (j) { if (j && j.accepted) markAccepted(j.accepted); })
		.catch(function () {});
	}

	setInterval(flush, FLUSH_INTERVAL_MS);
	document.addEventListener('visibilitychange', function () {
		if (document.visibilityState === 'hidden') flush();
	});
	window.addEventListener('pagehide', flush);

	window.__bsFlush = flush;
})();
